import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerProfile, DriverProfile } from '../models/common-data-types';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {

  constructor(private http: HttpClient) { }

  downloadDocument(id: string): Observable<Blob> {
    return this.http.get<Blob>(
      `https://api-dev.broker.crownly.co/broker/v1/selfcare/documents/${id}/download`,
      { responseType: 'blob' as 'json' }
    );
  }

  uploadDocument(payload: FormData): Observable<CustomerProfile> {
    return this.http.post<CustomerProfile>(`/selfcare/profile/documents`, payload)
  }

  download(id: string): Observable<any> {
    return this.http.get('/selfcare/documents/' + id + '/download', { observe:'response',responseType:'blob'});
  }
}
